export const parseInnerRouteFromLink = ({
  link,
  prefix,
}: {
  link: string
  prefix: string
}): string => {
  const innerRoute = link.slice(prefix.length + 2) // /prefix/
  return innerRoute
}
